import { useTokens } from '@reservoir0x/reservoir-kit-ui'
import { Button, Grid } from 'components/primitives'
import OpenSeaButton from 'components/common/OpenSeaButton'
import { ComponentPropsWithoutRef, FC } from 'react'

type Props = {
  token: ReturnType<typeof useTokens>['data'][0]
  isOwner: boolean
}

// Browse-only relaunch: native trading is parked, so the only action is the
// outbound OpenSea buy link (hidden on chains OpenSea doesn't support).
export const TokenActions: FC<Props> = ({ token, isOwner }) => {
  const buttonCss: ComponentPropsWithoutRef<typeof Button>['css'] = {
    width: '100%',
    height: 52,
    justifyContent: 'center',
    minWidth: 'max-content',
    '@sm': {
      maxWidth: 250,
    },
  }

  if (isOwner) return null

  return (
    <Grid
      align="center"
      css={{
        gap: '$4',
        gridTemplateColumns: 'repeat(1,minmax(0,1fr))',
        width: '100%',
        '@sm': {
          gridTemplateColumns: 'repeat(2,minmax(0,1fr))',
          maxWidth: 500,
        },
      }}
    >
      <OpenSeaButton
        contract={token?.token?.contract}
        tokenId={token?.token?.tokenId}
        buttonCss={buttonCss}
      />
    </Grid>
  )
}
